// Messages between the DevTools frontend (socket.js) and the session page (webrtc/devtools.js).

export const PORT_MESSAGE = "sauron:devtools-port";

export const OPENED = "opened";
export const FRAME = "frame";
export const CLOSED = "closed";
export const CLOSE = "close";
